import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'appointment-form',
  'provider-GW-details',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'appointments',
    'schedulings',
  ],
});

const initialState = {
  ...rootState,
  data: null,
};

const defaultRequestReducer = createReqReducer(consts);

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case consts.SEND: {
      return {
        ...initialState,
        sending: true,
        data: null,
      };
    }

    case consts.SUCCEED: {
      return {
        ...state,
        sending: false,
        succeed: true,
        data: payload,
      };
    }

    case consts.CLEAR: {
      return initialState;
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/provider-GW-details-req.js